import { Tooltip } from 'antd';
import { Moment } from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { HumanisedDate } from 'components/atoms/humanised-date';

const Indicator = styled.span`
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid var(--purple-60);
  height: 0;
  position: absolute;
  top: -8px;
  width: 0;
`;

export const CurrentDateIndicator: FC<{
  currentDate: Moment;
  result: number;
}> = ({ currentDate, result }) => (
  <Tooltip
    title={
      <>
        <FormattedMessage id="current_date" />
        <HumanisedDate timestamp={currentDate} />
      </>
    }
  >
    <Indicator style={{ left: `calc(${result}% - 10px)` }} />
  </Tooltip>
);
